import http from '@/shared/api/http'
import { IMAGE_ZIP_SIZE_MESSAGE, validateImageZipSize } from '../lib/productImageArchiveLimits'

function query(params = {}) {
  return Object.fromEntries(Object.entries(params).filter(([, value]) => value !== null && value !== undefined && value !== ''))
}

export function createProductImageImport(payload) {
  return http.post('/product-image-imports', payload).then(response => response.data)
}

export async function uploadProductImageArchive(jobId, file) {
  validateImageZipSize(file)
  const form = new FormData()
  form.append('file', file, file.name)
  return http.post(`/product-image-imports/${jobId}/archive`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 0
  }).then(response => response.data).catch(error => {
    if (error?.status === 413) throw new Error(IMAGE_ZIP_SIZE_MESSAGE)
    throw error
  })
}

export function getProductImageImport(jobId) {
  return http.get(`/product-image-imports/${jobId}`).then(response => response.data)
}

export function getProductImageImportEntries(jobId, page = 1, pageSize = 50) {
  return http.get(`/product-image-imports/${jobId}/entries`, {
    params: query({ page, pageSize }),
    timeout: 30000
  }).then(response => response.data)
}

export function updateProductImageImportEntry(jobId, entryId, payload) {
  return http.put(`/product-image-imports/${jobId}/entries/${entryId}`, payload).then(response => response.data)
}

export function preflightProductImageImport(jobId, expectedRevision) {
  return http.post(`/product-image-imports/${jobId}/preflight`, null, {
    params: { expectedRevision }
  }).then(response => response.data)
}

export function confirmProductImageImport(jobId, expectedRevision) {
  return http.post(`/product-image-imports/${jobId}/confirm`, null, {
    params: { expectedRevision }
  }).then(response => response.data)
}

export function applyProductImageImport(jobId, payload) {
  return http.post(`/product-image-imports/${jobId}/apply`, payload).then(response => response.data)
}
